import { render, staticRenderFns } from "./BaseSecondaryButton.vue?vue&type=template&id=4d4231d8&scoped=true&"
import script from "./BaseSecondaryButton.vue?vue&type=script&lang=js&"
export * from "./BaseSecondaryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4231d8",
  null
  
)

export default component.exports